import { FC, memo, useState } from 'react';
import { CellContext } from '@tanstack/react-table';
import { TextEllipsis, TextLink } from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './ClippedContentCell.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'clipped-content-cell',
);
addTranslations(translations);

export const ClippedContentCell: FC<
  CellContext<any, any> & {
    onShowMore: () => void;
  }
> = memo((props) => {
  const [isClipped, setIsClipped] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <TextEllipsis rows={6} onIsClipped={setIsClipped}>
        {props.renderValue()}
      </TextEllipsis>
      {isClipped && (
        <TextLink
          id={`${props.column.id}-${props.row.original.id}-read-more`}
          onClick={props.onShowMore}
        >
          {t('showMore')}
        </TextLink>
      )}
    </>
  );
});
